// extracted by mini-css-extract-plugin
module.exports = {"Title":"Heading_Title__NhYxK","headingBorder1":"Heading_headingBorder1__1ocbZ","headingBorder2":"Heading_headingBorder2___-8hc"};